import { useCanEditDailyLogs } from './DailyLogsTab';
import SitePhotoThread from './SitePhotoThread';

/**
 * The job's Photos tab, in the Documents group of the project menu (#665).
 *
 * ⚠️ Not a second gallery. It is the same site photo thread the Daily Logs
 * tab shows under its "Photos" switch (PR #560): the same component, the same
 * GET /site-photos, the same files in the Job Folder. Who may read, post and
 * remove is decided by that route and its service, exactly as before, so a
 * second way in cannot widen who sees or posts anything.
 *
 * The props are the Daily Logs tab's, on purpose: the same "may post" hint
 * (useCanEditDailyLogs), the job's activity lock, and a day's "Daily log" chip
 * that opens that log on the Daily Logs tab.
 */
export default function PhotosTab({
  projectId,
  locked = false,
  onOpenLog,
}: {
  projectId: number;
  locked?: boolean;
  onOpenLog: (logId: number) => void;
}) {
  const canPost = useCanEditDailyLogs();
  return <SitePhotoThread projectId={projectId} canPost={canPost} locked={locked} onOpenLog={onOpenLog} />;
}
